@if (withShell) {
<astral-field-shell [control]="control" [forId]="resolvedInputId" [helpText]="helpText">
  <div class="astral-masked-input__layout" [class.astral-masked-input__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
</astral-field-shell>
} @else {
  <div class="astral-masked-input__layout" [class.astral-masked-input__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
}

<ng-template #inputTemplate>
  <div
    class="astral-masked-input"
    [class.astral-masked-input--readonly]="control?.isReadonly"
    [class.astral-masked-input--disabled]="control?.disabled"
    [class.astral-masked-input--focused]="isFocused"
  >
    <div class="astral-masked-input__actions">
      @if (showClearOthers) {
        <astral-field-action
        icon="clearOthers"
        titleKey="COMMON.CLEAR_OTHER_FILTERS"
        ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
        (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
        icon="clear"
        titleKey="COMMON.CLEAR"
        ariaLabelKey="COMMON.CLEAR"
        (click)="clearInput()"
        ></astral-field-action>
      }
    </div>

    <div class="astral-masked-input__control-shell" [class.astral-masked-input__control-shell--readonly]="control?.isReadonly">
      @if (control?.isReadonly) {
        <span class="astral-masked-input__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      <input
        #input
        astralFieldAccessibility
        [astralFieldControl]="control"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        class="astral-masked-input__control"
        [formControl]="control"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [attr.inputmode]="inputMode"
        [attr.autocomplete]="autocomplete"
        [attr.placeholder]="resolvedPlaceholderText ? (resolvedPlaceholderText | translate) : null"
        [readonly]="control?.isReadonly ? true : null"
        [required]="control?.required ? true : null"
        [class.astral-masked-input__control--center]="textAlignCenter"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
        (input)="handleInput(input.value)"
      />
    </div>
  </div>
</ng-template>

<ng-template #supplementalLabelTemplate>
  @if (resolvedSupplementalLabel) {
    <span class="astral-masked-input__supplemental-label">
      {{ resolvedSupplementalLabel | translate }}
    </span>
  }
</ng-template>
